// extracted by mini-css-extract-plugin
export default {"icon":"LoginScreen_icon__fe0Ms","loginBtn":"LoginScreen_loginBtn__LEC4Z","loginContainer":"LoginScreen_loginContainer__MRZWp"};